import React, { Fragment, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// Material UI Components
import { Alert } from "@material-ui/lab";
import { Button, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Local
import { useDispatch } from "react-redux";
import { SET_NAVBAR_TITLE } from "action_creators/actioncreator";
import CustomTable from "../components/Table";
import AddNodeModal from "./components/AddNodeModal";
import RightDrawer from "../components/RightDrawer";
import LoaderHoc from "../../../components/HOC/LoaderHoc";
import { SDCloudBackendAPIWithToken } from "../../../apis/backendAPI";
import { IconButton } from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import EditIcon from '@material-ui/icons/Edit';
import { SHOW_NOTIFICATION } from "action_creators/actioncreator";
import { getDesignerObjects } from "../../../apis/APIServices";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Typography } from "@material-ui/core";
import ShimmerUserTable from "../../Usermanagement/components/ShimmerUserTable";
import { NODE_URLS } from "views/ServiceLifeCycle/utils/constants/urls";
// Styling
const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "50px",
  },
  item: {
    textAlign: "end",
  },
  button: {
    background: `${theme.palette.buttonColor.main} !important`,
    height: "40px",
    color: "white",
    border: "none",
    width: "15%",
    fontSize: "0.875rem",
    fontFamily: `${theme.palette.fontList.selectedFont} !important`,
    cursor: "pointer",
  },
  container: {
    float: "right",
  },
}));

const ViewTraining = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [rows, setrows] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [currentScreen, setCurrentScreen] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [isModal, setIsModal] = useState(false);
  const [currentTraining, setCurrentTraining] = useState("");
  const [currentRef, setCurrentRef] = useState("");
  const [trainingDescription, setTrainingDescription] = useState("");
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState([]);
  const [recordCount, setrecordCount] = useState(10);
  const [searchValue, setsearchvalue] = useState("");
  const [pageNo, setpageNo] = useState(1);
  const [rowstemp, setrowstemp] = useState([]);
  const [notificationType, setNotificationType] = useState("");
  useEffect(() => {
    dispatch(SET_NAVBAR_TITLE(" Designer Elements"));
    localStorage.removeItem("node_id");
    localStorage.removeItem("node_name");
    localStorage.removeItem("node_version");
    localStorage.removeItem("design_objects");
    getDesignObjects();
    renderrow(pageNo,recordCount,searchValue);
  }, [pageNo,recordCount,searchValue]);
  // States
  const columns = [
    {
      Header: "Icon",
      accessor: "icon_url",
    },
    {
      Header: "Element ID",
      accessor: "element_id",
    },
    {
      Header: "Element Name",
      accessor: "element_name",
    },
    {
      Header: "Element Version",
      accessor: "element_version",
    },
    {
      Header: "Element State",
      accessor: "element_state",
    },
    {
      Header: "Action",
      accessor: "action",
    },
  ];

  const getDesignObjects = async () => {
    const designObject = localStorage.getItem("design_objects");
    if (!designObject) {
      const response = await getDesignerObjects();
      if (response.success) {
        localStorage.setItem("design_objects", JSON.stringify(response.data));
      }
    }
  };

const handleBack = () => {
  history.push("/inventory-management"); 
};
  let data = [];
  const renderrow = async (page_no,record_count,search_value) => {
    return SDCloudBackendAPIWithToken()
        .get(`/inventory/list_designer_nodes?search=${search_value ??
          searchValue}&page_no=${
          page_no ? page_no : pageNo
        }&record_count=${record_count? record_count:recordCount}`)
        .then((resp) => resp.data)
        .then((resp) => {
            resp.nodes.forEach((item) => {
                data.push({
                  element_id: item.nodeid,
                  element_name: item.name,
                  element_version:item.version,
                  element_state:item.state,
                  icon_url: (<div className="display-icon">
                  {item.icon_url.trim() !== "" ? (
                    <img
                      className="img-fluid image-dim"
                      src={item.icon_url}
                      alt=""
                      style={{width:"40px",height:"40px"}}
                    ></img>
                  ) : (
                    item.icon_url
                  )}
                </div>),
                  action: (
                    <IconButton onClick={() => handleViewButton(item.nodeid, item.name, item.version)}>
                      <EditIcon />
                    </IconButton>
                  ),
                });
              });
              setrows(data);
              setIsLoading(false);
              setrowstemp(resp);
        })
        .catch((err) => {
        
        }); 
  };

  const handleDeleteButton = (selectedRowIds, selectedFlatRows) => {
     // alert("This functionality is currently not available")
    // return false;
    if (window.confirm("Are you sure you want to delete the node?")){
      let payload = {};
      selectedFlatRows.forEach((item) => {
        let node_name = item.original.element_name;
        payload["node_name"] = node_name;
        payload["node_id"] = item.original.element_id;
        payload["version"] = item.original.element_version;
        payload["bucket_name"] = NODE_URLS.BUCKET_NAME
        SDCloudBackendAPIWithToken()
          .post(`/inventory/delete_designer_node`, payload)
          .then((resp) => resp.data)
          .then((data) => {
            setShowNotification(true);
            setNotificationType("success");
            setNotificationMessage("Node deleted successfully")
            
            renderrow();
          })
          .catch((err) => {
          let message = err.response.data.message;
          setShowNotification(true);
          setNotificationType("error");
          setNotificationMessage("Failed to delete the node")
        });
      });
    }
  };
  const handleViewButton = (nodeid, name, version) => {
    history.push("/create-element?id="+nodeid+"&name="+name+"&version="+version+"&mode=edit"); 
  };

  const handleAddButton = (nodeid, name, version) => {
    //setIsModal(true)
    history.push("/create-element?mode=add"); 
  };

  const handleAddNodeButton = (nodeid, name, version) => {
    history.push("/create-element?id="+nodeid+"&name="+name+"&version="+version+"&mode=edit"); 
  };

  const renderNotififications = () => {
    // let notifications = notificationMessage.map((item) => {
    // let notificationType = item.success ? "success" : "error";
      return (
        <Alert
          onClose={() => setShowNotification(false)}
          severity={notificationType}
          spacing={1}
        >
          {notificationMessage}
        </Alert>
      );
    // });

    // return notifications;
  };
  const handleDataSearch = (search_value) => {
    setsearchvalue(search_value);
  };
  const handlePagination = (page_no,record_count) => {
    setrecordCount(record_count)
    setpageNo(page_no);
  };
  return (
    <div>
       <Grid container className="backbutton">
      <Grid item xs={12}>
        <Typography
          variant="body1"
          style={{ cursor: "pointer", display: "flex", alignItems: "center", marginBottom: "20px" }}
          onClick={handleBack}
        >
          <ArrowBackIcon style={{ marginRight: "8px" }} /> Back
        </Typography>
      </Grid>
    </Grid>
      <Grid container className={classes.root} spacing={1}>
        <Grid item style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={handleAddButton}
                variant="contained"
                color="secondary"
                disableElevation
                size="large"
                fullWidth
                disableFocusRipple
                className={classes.btnColor}
                type="submit"
                style={{ height: "40px", marginRight: "10px" }}
              >
                Add New Custom Element
              </Button>
            </Grid>
          {isModal && (
          <AddNodeModal
            visible={isModal}
            onClose={() => {
              setIsModal(false);
            }}
          />
        )}
        <Grid item xs={12} md={12}>
          {showNotification ? renderNotififications() : null}
        </Grid>
        <Grid item xs={12} md={12}>
           {isLoading ? (
              <ShimmerUserTable />
            ) : (
              <CustomTable
              columns={columns}
              data={rows}
              handleDeleteButtonClick={handleDeleteButton}
              handleViewButtonClick={handleViewButton}
              tableTitle="Designer Elements"
              hiddenColumns={[]}
              count={rowstemp?.pagination?.total_pages}
              page={rowstemp?.pagination?.current_page}
              setNodeList={handlePagination}
              handleSearch={handleDataSearch}
            />
            )}
        </Grid>
      </Grid>
    </div>
  );
};

export default ViewTraining;
